import { Privileges } from '../../proto/tumelo/stewardshipbff/v1/user'
import { sampleScheme } from './scheme'

export const samplePrivileges = (override?: Partial<Privileges>): Privileges =>
  Privileges.fromPartial({
    canVoteOnSchemes: { [sampleScheme().name]: true },
    canViewMeetingsWithinSchemes: { [sampleScheme().name]: true },
    ...override,
  })
